<template>
  <div class="header-player"
    v-show="$root.deviceAudioSrc && !($root.route[0] === 'HomePage')"
    @click="$root.goto('DevicePage')">
    <span style="width:100%;color:#afd2ef;padding: 3px;">
      Now Playing on Device
    </span>
   
    <div class="left-item">
      <img
      :src="'//classicalwalkoffame.org/inductees/' + inductee.ImageURL">
    </div>
    
    <div class="middle-item">
        <span class="name">{{ inductee.InducteeName }}</span><br>
        <span class="song">{{ inductee.MusicTitle }}</span><br>
    </div>
    
    <div class="right-item" @click.stop>
      <sprite-button class="homeButton"
      @click="$root.togglePauseOnDevice()"
      :background-url="buttonImg"
      width="56px"
      height="50px"
      >Play</sprite-button>
      <sprite-button
      @click="$root.stopOnDevice()"
      background-url="img/stop_button.png"
      width="56px"
      height="50px"
      >Stop</sprite-button>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    buttonImg () {
      return this.$root.deviceAudioPaused ? 'img/play_button.png' : 'img/pause_button.png'
    },
    inductee () {
      return this.$root.nowPlaying('device')
    }
  },
}
</script>

<style lang="less">
.header-player {
  display: flex;
  flex-flow: row wrap;
  cursor: pointer;
  
  .left-item {
    img {
      width: 40px;
      height: 40px;
      margin: 5px;
    }
  }
  .middle-item {
    flex: 1;
    padding: 5px;
  }
  .name {
    color: #fff;
    font-family: "myriad-pro", arial, sans-serif;
    font-weight: bold;
    font-size: 16px;
  }
  .song {
    color: #afd2ef;
    font-family: "myriad-pro", arial, sans-serif;
    font-weight: normal;
    font-style: italic;
    font-size: 15px;
  }
  .right-item {
    .sprite-button {
      display: inline-block;
      margin-left: -10px;
    }
  }
}
</style>